import type { IUserRepository } from "@src/domain/users/repository/user.repository.interface";
import type { UserDTO } from "../dto/user.dto";
import type { UpdateProfileInputDTO } from "../dto/user-input.dto";
import { UserDtoMapper } from "../mappers/user-dto.mapper";

/**
 * Use Case: Update Profile
 * Updates authenticated user's profile information
 */
export class UpdateProfileUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    /**
     * Execute the use case
     * @param data - Profile update data
     * @returns Promise<UserDTO> - Updated user DTO
     * @throws Error if validation fails
     */
    async execute(data: UpdateProfileInputDTO): Promise<UserDTO> {
        this.validateProfileData(data);

        const user = await this.userRepository.updateProfile(data);
        return UserDtoMapper.toDTO(user);
    }

    /**
     * Validate profile data
     * @param data - The data to validate
     * @throws Error if validation fails
     */
    private validateProfileData(data: UpdateProfileInputDTO): void {
        if (!data.first_name || !data.first_name.trim()) {
            throw new Error('First name is required');
        }

        if (!data.last_name || !data.last_name.trim()) {
            throw new Error('Last name is required');
        }
    }
}
